<aside class="qc-sub-content order-content-detail__container scrollable" *ngIf="isSubContentPanelOpen">
	<diV class="qc-sub-content__header">Order Detailed Information</diV>
	<div *ngIf="data && data.id; else emptySelection">
		<div class="main-picture__section" *ngIf="mainPicture">
			<img [src]="mainPicture.path" class="main-picture" />
		</div>
		<div class="main-picture__section-empty" *ngIf="!mainPicture">
			<label>No photo available</label>
		</div>
		<div class="detail__info">
			<label class="description">{{ data.description }}</label>
		</div>
		<div class="card-detail__title" *ngIf="data.workableMessage && data.workableMessage !== ''">
			<label class="data-value" *ngIf="data.isWorkable === true">Things to consider on this ORDER:</label>
			<label class="data-value" *ngIf="data.isWorkable === false">This order can't be accessed because:</label>
			<label class="data-field">{{ data.workableMessage }}</label>
		</div>
		<div class="order-activity-btn-wrapper">
			<button
				pButton
				type="button"
				class="order-activity-btn p-button-secondary p-button-outlined p-button-sm"
				(click)="openOrderActivityDialog()"
				label="View Activity"
				icon="pi pi-replay"
			></button>
		</div>
		<div class="card-detail__title" *ngIf="orderUsers.length">
			<label class="data-field">Currently working on this order</label>
			<div
				class="btn-circular cv-users-box-initials"
				*ngFor="let user of orderUsers"
				cvTooltip
				[tooltipText]="user.fullName"
				[tooltipPlacement]="'bottom'"
			>
				<span>{{ user.initials }}</span>
			</div>
		</div>
		<div *ngFor="let detail of orderDetailFields; let even = even">
			<div class="card-detail__title" [ngClass]="{ filled: even }">
				<label class="data-field">{{ detail.name }}</label>
				<label class="data-value">{{ detail.value ? detail.value : 'N/A' }}</label>
			</div>
		</div>
		<div *ngIf="isGSE">
			<div class="card-detail__title filled">
				<label class="data-field">Status Message</label>
				<label class="data-value">{{ data.statusMessage }}</label>
			</div>
		</div>
		<div *ngIf="orderAutoQCstatus.id !== ''">
			<ng-container *ngIf="orderAutoQCstatus.requiresRulesValidation">
				<div class="detail__info">
					<label class="description">Validation</label>
				</div>
				<div class="row gx-0">
					<div class="col-4">
						<div class="card-detail__title filled">
							<label class="data-field">Date</label>
							<label class="data-value">{{ orderAutoQCstatus.rulesValidationdDate | date }}</label>
						</div>
					</div>
					<div class="col-8">
						<div class="card-detail__title filled">
							<label class="data-field">Passed?</label>
							<label class="data-value">
								{{ orderAutoQCstatus.rulesValidationPassed ? 'Yes' : 'No' }}
							</label>
						</div>
					</div>
				</div>

				<div class="card-detail__title filled">
					<label class="data-field">Message</label>
					<label class="data-value">{{ orderAutoQCstatus.ruleValidationMessage || 'N/A' }}</label>
				</div>
			</ng-container>
			<ng-container *ngIf="orderAutoQCstatus.requiresCUScoreValidation">
				<div class="detail__info">
					<label class="description">Smart QC</label>
				</div>
				<div class="row gx-0">
					<div class="col-4">
						<div class="card-detail__title filled">
							<label class="data-field">Date</label>
							<label class="data-value">{{ orderAutoQCstatus.cuScoreValidationDate | date }}</label>
						</div>
					</div>
					<div class="col-4">
						<div class="card-detail__title filled">
							<label class="data-field">Passed?</label>
							<label class="data-value">
								{{ orderAutoQCstatus.cuScoreValidationPassed ? 'Yes' : 'No' }}
							</label>
						</div>
					</div>
					<div class="col-4">
						<div class="card-detail__title filled">
							<label *ngIf="orderAutoQCstatus.cuScore" class="data-field">CU Score</label>
							<label class="data-value">{{ orderAutoQCstatus.cuScore }}</label>
						</div>
					</div>
				</div>
				<div class="card-detail__title filled">
					<label class="data-field">Message</label>
					<label class="data-value">{{ orderAutoQCstatus.cuScoreValidationMessage || 'N/A' }}</label>
				</div>
			</ng-container>
		</div>
	</div>
	<ng-template #emptySelection>
		<div class="empty-selection__content">
			<label class="empty-selection__icon"><i class="fas fa-file"></i></label>
			<label class="empty-selection__lbl">No Order Selected</label>
			<label class="empty-selection-instruction__lbl"
				>Select an order from the list to see detailed information about</label
			>
		</div>
	</ng-template>
	<div class="loading" *ngIf="loading">
		<div class="message-container">
			<i class="fa fa-spin fa-spinner"></i>
		</div>
	</div>
</aside>
